import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { ChordEditBlastRadius } from "../../models/ChordHistoryOptions.model";
import OptionMenuToggle from "../theme_reuse/OptionMenuToggle";

interface Props {}
interface State {}

const TITLE = "When you save changes to a chord...";
const shortNames = [ChordEditBlastRadius.OnlyThisInstance, ChordEditBlastRadius.AllInstances];
const descriptions = [
  "Your change only applies to the current chord.",
  "Your change applies to all instances of the same chord.",
];

function printShortName(x: ChordEditBlastRadius): string {
  switch (x) {
    case ChordEditBlastRadius.OnlyThisInstance:
      return "Only One";
    case ChordEditBlastRadius.AllInstances:
      return "All Matching";
  }
}

export default class ChordEditBlastRadiusToggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeBlastRadius = (blastRadius: ChordEditBlastRadius) => {
    const oldEdits = this.context.chordHistoryOptions.edits;
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { ...oldEdits, edits: { blastRadius } } });
  };

  render(): ReactNode {
    const blastRadius = this.context.chordHistoryOptions.edits.blastRadius;
    return (
      <OptionMenuToggle
        title={TITLE}
        optionShortNames={shortNames}
        optionDescriptions={descriptions}
        selected={blastRadius}
        printShortName={printShortName}
        onChange={this.changeBlastRadius}
      />
    );
  }
}

ChordEditBlastRadiusToggle.contextType = AppContextType;
